import SideBar from './SideBar-compose';

export default SideBar;
